<template>

    <circlesContainer class="agility_score_item" :pose="containerIsVisible ? 'visible' : 'hidden'" >
        <div class="agility_score_item_circles" :class="scoreClass()">

            <circleScore class="circle_item" :class="{active: (score.toFixed(0) >= 5)}">
                <span class="score">5</span>
            </circleScore>

            <circleScore class="circle_item" :class="{active: (score.toFixed(0) >= 4)}">
                <span class="score">4</span>
            </circleScore>

            <circleScore class="circle_item" :class="{active: (score.toFixed(0) >= 3)}">
                <span class="score">3</span>
            </circleScore>

            <circleScore class="circle_item" :class="{active: (score.toFixed(0) >= 2)}">
                <span class="score">2</span>
            </circleScore>

            <circleScore class="circle_item" :class="{active: (score.toFixed(0) >= 1)}">
                <span class="score">1</span>
            </circleScore>

        </div>
        <div class="agility_score_item_label">{{ labels[dimId] }}</div>
    </circlesContainer>

</template>

<script>
    import posed from 'vue-pose';
    import s3AgilitiesLabels from '@/locales/s3AgilitiesLabels'

    export default {
        name: 'AgilityScore',
        props: ['score', 'dimId', 'animDelay'],
        components: {
            circlesContainer: posed.div({
                visible: {
                    opacity: 1,
                    x: 0,
                    beforeChildren: true,
                    staggerChildren: 50
                },
                hidden: {
                    opacity: 0,
                    x: '-100%',
                    afterChildren: true
                }
            }),
            circleScore: posed.div({
                visible: { opacity: 1, scale: 1 },
                hidden: { opacity: 0, scale: 0 },
                hoverable: true,
                init: { scale: 0.2 },
                hover: { scale: 1.2 }
            })
        },
        mounted() {
            setTimeout(() => {
                this.containerIsVisible = true;
            }, this.animDelay);
        },
        data(){
            return {
                isVisible1: false,
                isVisible2: false,
                isVisible3: false,
                isVisible4: false,
                isVisible5: false,
                containerIsVisible: false
            }
        },
        computed: {
            currentEval(){
                return this.$store.state.EvalStore.currentEval
            },
            labels(){
                return s3AgilitiesLabels[this.$i18n.locale]
            }

        },
        methods: {
            scoreClass(){
                return "is_score_" + this.score.toFixed(0)
            }
        }
    }
</script>

<style lang="scss" scoped>
.agility_score_item{
    width: 160px;
    border-left: 1px solid $grey-lighter;
    .agility_score_item_circles{
        display: flex;
        flex-direction: column;
        align-items: center;
        .circle_item{
            width: 48px;
            height: 48px;
            border-radius: 100%;
            background: $grey-lighter;
            display: flex;
            justify-content: center;
            align-items: center;
            span{
                color: $white;
                font-weight: 600;
            }
            &.active{
                background-color: $info;
            }
        }
        // &.is_score_1 .circle_item.active{
        //     background-color: $score-diff5;
        // }
        // &.is_score_2 .circle_item.active{
        //     background-color: $score-diff4;
        // }
        // &.is_score_3 .circle_item.active{
        //     background-color: $score-diff3;
        // }
        // &.is_score_4 .circle_item.active{
        //     background-color: $score-diff2;
        // }
        // &.is_score_5 .circle_item.active{
        //     background-color: $score-diff1;
        // }
    }
    .agility_score_item_label{
        margin-top: 30px;
        text-align: center;
        font-weight: 600;
        text-transform: uppercase;
        color: $grey-light;
        width: 100px;
        margin-left: auto;
        margin-right: auto;
    }
}
</style>